<template>
  <div class="footer">
    <div
      class="footer-content d-flex align-items-center justify-content-center"
    >
      <div
        class="d-flex flex-column flex-lg-row align-items-center align-items-lg-baseline"
      >
        <img
          class="footer-logo"
          src="https://ik.imagekit.io/1pzxddx3qqv/KUMA_Official/image/logo.png"
          alt="logo"
          loading="lazy"
        />
        <div class="footer-copy-right my-3 my-lg-0">
          Copyright © 2025-2026 KUMA Info All Rights Reserved
        </div>
        <div
          class="footer-privacy-btn"
          @click="goPage('/smartSupport/privacyPolicy')"
        >
          Privacy Policy
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useCommon } from "@/composables/useCommon";

const { goPage } = useCommon();
</script>
